module.exports = __webpack_public_path__ + "static/media/AgencyIco.ebc3357b.svg";